import 'regenerator-runtime/runtime';
import { html, LitElement, TemplateResult, unsafeCSS } from 'lit-element';
import { Slotify } from '@eightshapes/slotify';
import css from './graphical-progress.scss';

export default class ApxGraphicalProgress extends Slotify(LitElement) {
  public render(): TemplateResult {
    return html`
      <style>
        ${unsafeCSS(css)}
      </style>
      <s-slot></s-slot>
    `;
  }
}

// it is required to do it this way instead of using the customElements decorator
// as this component may be imported numerous times
if (!window.customElements.get('apx-graphical-progress')) {
  // @ts-ignore
  window.customElements.define('apx-graphical-progress', ApxGraphicalProgress);
}
